import { render, staticRenderFns } from "./jsIndex.vue?vue&type=template&id=a236ccf0&"
import script from "./jsIndex.vue?vue&type=script&lang=js&"
export * from "./jsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "jsIndex.vue"
export default component.exports